<template>
    <button class="returnBTN" @click="this.$router.push({name: 'profile'})"><img src="../assets/icons/arrow.png"/></button>
    <button @click="this.$router.push({name: 'credits'})">Credits</button><br/>
    <button @click="this.$router.push({name: 'mentionslegales'})">Mentions Légales</button>
</template>